import { Form } from "antd";
import { FormInstance } from "antd/lib/form";
import FormHeaderTitle from "../../../Invoice(Visa)/Components/FormHeaderTitle";
import HajjPassengerInfoList from "../../Invoice_Hajj/Components/HajjPassengerInfoList";
import PackageRateHajiInfo from "./PackageRateHajiInfo";

type Props = { form: FormInstance<any>; clientId: number };

export default function PackageRateAddPilgrimsInfo({ form, clientId }: Props) {
  return (
    <div className="border p-5 my-20">
      <FormHeaderTitle title="Pilgrims Information" />
      <Form.List name="pilgrims_information" initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }, index) => (
              <PackageRateHajiInfo
                key={key}
                name={name}
                form={form}
                index={index}
                add={add}
                remove={remove}
                clientId={clientId}
              />
            ))}
          </>
        )}
      </Form.List>
    </div>
  );
}
